import {
    accentColorValues,
    blue,
    green,
    indigo,
    orange,
    pink,
    purple,
    red,
    teal
} from './colors'

const primaryPresets = {
    blue,
    green,
    indigo,
    orange,
    pink,
    purple,
    red,
    teal
}

export const getPrimary = (preset) => {
    const resolvedPreset = primaryPresets[preset]
    if (resolvedPreset) return resolvedPreset

    console.error(
        `Invalid color preset, accepted values: ${accentColorValues
            .map((value) => `"${value}"`)
            .join(', ')}.`
    )
    return blue
}
